import React from 'react'

export default function Tidal(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={15}
            height={15}
            fill="none"
            {...props}
        >
            <path
                fill="#fff"
                d="M5.313 5.273 2.89 7.734.469 5.274 2.89 2.811l2.422 2.461ZM10.156 5.273 7.735 7.734l-2.422-2.46 2.422-2.462 2.421 2.461 2.422-2.46L15 5.272l-2.422 2.461-2.422-2.46ZM7.735 12.656l2.421-2.46-2.421-2.462-2.422 2.461 2.422 2.461Z"
            />
        </svg>
    )
}
